export { ResponsiveImage } from "./ResponsiveImage";
export type { ResponsiveImageProps } from "./ResponsiveImage";
